export default __webpack_public_path__ + "static/media/13.718d1c68.jpg";